import React from 'react';
import {
  FaHome,
  FaSignInAlt,
  FaBook,
  FaCircle,
  FaPowerOff,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import logo from '../../img/logo.svg';
import history from '../../services/history';
import * as actions from '../../store/modules/auth/actions';
import { Nav } from './styled';

export default function SideBar() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(actions.loginFailure());
    history.push('/');
  };

  return (
    <Nav>
      <div>
        <img src={logo} alt="logo" title="logo" />
      </div>
      <Link to="/" title="Principal">
        <FaHome size={20} />
      </Link>
      <Link to="/relatorios" title="Relatórios">
        <FaBook size={20} />
      </Link>
      {isLoggedIn ? (
        <Link onClick={handleLogout} to="/logout" title="Sair">
          <FaPowerOff size={20} />
        </Link>
      ) : (
        <Link to="/login" title="Logar">
          <FaSignInAlt size={20} />
        </Link>
      )}
      {isLoggedIn && <FaCircle size={20} color="#66ff33" title="Logado" />}
    </Nav>
  );
}
